import React from "react";

const Page500 = () => {
  return <div>Nimate pravic.</div>;
};

export default Page500;
